var _rect, _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1172_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 33,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2492 32.3777C25.2234 32.3777 32.4984 25.3536 32.4984 16.6889C32.4984 8.02414 25.2234 1 16.2492 1C7.27501 1 0 8.02414 0 16.6889C0 25.3536 7.27501 32.3777 16.2492 32.3777Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1172_2)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93908 40.2209C13.8761 40.2209 17.8783 36.3567 17.8783 31.5899C17.8783 26.8231 13.8761 22.9589 8.93908 22.9589C4.00206 22.9589 -0.000183105 26.8231 -0.000183105 31.5899C-0.000183105 36.3567 4.00206 40.2209 8.93908 40.2209Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1172_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 1,
    width: 3,
    height: 25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95581 25.0208V1.88968H9.94859V25.0208H7.95581Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1172_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4984 16.6889C32.4984 25.3537 25.2235 32.3777 16.2492 32.3777C7.2751 32.3777 6.10352e-05 25.3537 6.10352e-05 16.6889C6.10352e-05 8.02418 7.2751 1.00003 16.2492 1.00003C25.2235 1.00003 32.4984 8.02418 32.4984 16.6889Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendle);
export default __webpack_public_path__ + "static/media/PENDLE.a55d794ec9a5b99d19425f6c3182a9cf.svg";
export { ForwardRef as ReactComponent };